/* eslint-disable */
<template>
  <svg
    class="filter__search-icon"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.504 4.20022C11.4552 4.08228 11.3829 3.97178 11.287 3.8759C11.1061 3.69494 10.8561 3.58301 10.5799 3.58301H4.74658C4.1943 3.58301 3.74658 4.03072 3.74658 4.58301C3.74658 5.13529 4.1943 5.58301 4.74658 5.58301H8.1657L4.03948 9.70923C3.64895 10.0998 3.64895 10.7329 4.03948 11.1234C4.43 11.514 5.06316 11.514 5.45369 11.1234L9.57992 6.99722V10.4163C9.57992 10.9686 10.0276 11.4163 10.5799 11.4163C11.1322 11.4163 11.5799 10.9686 11.5799 10.4163V4.58301C11.5799 4.44742 11.5529 4.31813 11.504 4.20022Z"
      fill="currentColor"
    />
  </svg>
</template>